import injector from 'vue-inject'
import AuthService from './auth.service'
import UserService from './user.service'
import MaintenanceService from './maintenance.service'
import AdminService from './admin.service'
import DynamicCallService from './dynamic-call.service'
import MenuService from './menu.service'
import GenericService from './generic.service'
import StorageService from './storage.service'

injector.service('AuthService', ['axios'], AuthService)
injector.service('UserService', ['axios'], UserService)
injector.service('MaintenanceService', ['axios'], MaintenanceService)
injector.service('AdminService', ['axios'], AdminService)
injector.service('DynamicCallService', ['axiosPure'], DynamicCallService)
injector.service('MenuService', ['menu'], MenuService)
injector.service('GenericService', ['axios'], GenericService)
injector.service('StorageService', [], StorageService)
